<div class="cosmos-image__container">
  <img
    *ngIf="!!src"
    [src]="src | formatUrl"
    class="cosmos-image__container__image"
    loading="lazy"
  />
</div>
